// Frontend
import Modal from 'react-modal';
import { Grid, Cell } from 'react-foundation';
import { InfoCircleFill, XCircle } from 'react-bootstrap-icons';
import '../stylesheets/components/forms/Categories.css';

// Functionality
import { questionCategoryModifier } from '../constants/SharedComponents';
import QuestionCategoryContent from './QuestionCategoryContent';
import PropTypes from 'prop-types';

// Configurations
Modal.setAppElement('#root');

const QuestionCategory = ({
  questionCategory,
  openModal,
  currentModal,
  afterOpenModal,
  closeModal,
  submissionUnlocked,
  handleChange,
  questionResultsContent,
  deselectCategory,
  selectCategory,
  categoryFormButtons,
  selectedCategories,
  showSummary,
  showNotes,
  handleCheckbox: parentHandleCheckbox,
  isManagerView = false,
}) => {
  const defaultHandleCheckbox = (id) => {
    let allCategories = Array.from(document.querySelectorAll('input[type="checkbox"]:checked'))
      .map(checkbox => checkbox.getAttribute('data-category-id'));

    if (allCategories.length > 3) {
      let currentCheckbox = document.getElementById(`checkbox--${id}`);
      if (currentCheckbox) {
        currentCheckbox.checked = false;
      }
    }
  };

  // Use parent handleCheckbox if provided, otherwise use default
  const handleCheckbox = parentHandleCheckbox || defaultHandleCheckbox;

  return (
    <>
      {!submissionUnlocked && (
        <div className="category-form-field-wrap">
          <div className={`category-form-field category-form-field--${questionCategoryModifier(questionCategory)}`}>
            <p className={`category-form-field__title category-form-field__title--${questionCategoryModifier(questionCategory)}`}>
              {questionResultsContent(questionCategory.id, 'optionalCategoryName') || questionCategory.name}
            </p>

            {showSummary && (
              <div className="category-form-field__styles category-form-field__styles--selected">
                <div>
                  {questionCategory.description}{' '}
                  <button
                    onClick={openModal}
                    data-modal-id={`question-category-content--${questionCategory.id}`}
                    className="category-form-field__link"
                    id={`page-function-button--view-${questionCategory.id}`}
                  >
                    More
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      {submissionUnlocked && (questionCategory.name.includes("Guided Optional") || questionCategory.name.includes("Self-Guided Optional")) && selectCategory && (
        <div className="category-form-field-wrap" style={{ position: 'relative' }}>
          <div className={`category-form-field shadow-sm category-form-field--${questionCategoryModifier(questionCategory)}`}>
            <div style={{ position: 'relative' }}>
              <p className="category-form-field__title category-form-field__title--personalised">
                <InfoCircleFill className="category-form-field__icon" />
                <b>Personalised topic</b>
              </p>

              <label className='custom-checkbox'>
                <span className="visually-hidden">
                  Select {questionResultsContent(questionCategory.id, 'optionalCategoryName') || questionCategory.name}
                </span>
                <input
                  className="basic-form__input"
                  type="checkbox"
                  data-category-id={questionCategory.id}
                  id={`checkbox--${questionCategoryModifier(questionCategory)}`}
                  onChange={() => handleCheckbox(questionCategoryModifier(questionCategory))}
                  aria-label={`Select ${questionResultsContent(questionCategory.id, 'optionalCategoryName') || questionCategory.name}`}
                />
                <span className="checkmark"></span>
              </label>
            </div>

            <input
              id={`optionalCategoryName--${questionCategory.id}`}
              name={`optionalCategoryName--${questionCategory.id}`}
              onChange={handleChange}
              placeholder="Add your own topic title"
              defaultValue={questionResultsContent(questionCategory.id, 'optionalCategoryName')}
              className="basic-form__input category-form-field__input category-form-field__input--self-guided"
            />
          </div>
        </div>
      )}

      {submissionUnlocked && (questionCategory.name.includes("Guided Optional") || questionCategory.name.includes("Self-Guided Optional")) && deselectCategory && (
        <div className="category-form-field-wrap">
          <div className={`category-form-field category-form-field--${questionCategoryModifier(questionCategory)}`}>
            <Grid className="grid-padding-x">
              <Cell small={12} large={8}>
                <p className={`category-form-field__title category-form-field__title--${questionCategoryModifier(questionCategory)}`}>
                  {questionResultsContent(questionCategory.id, 'optionalCategoryName') || questionCategory.name}
                </p>

                {showSummary && (
                  <div className="category-form-field__styles category-form-field__styles--selected">
                    <div>
                      <button
                        onClick={openModal}
                        data-modal-id={`question-category-content--${questionCategory.id}`}
                        className="category-form-field__link"
                        id={`page-function-button--view-${questionCategory.id}`}
                      >
                        More
                      </button>
                    </div>
                  </div>
                )}
              </Cell>
              <Cell small={12} large={4} className="text-right">
                <button
                  data-category-id={questionCategory.id}
                  onClick={deselectCategory}
                  ref={(ref) => (categoryFormButtons.current['selected' + questionCategory.id] = ref)}
                  id={`page-function-button--remove-${questionCategory.id}`}
                >
                  <span className="category-form-field__link">Remove</span>
                  <XCircle
                    size={16}
                    className="category-form-field__button-icon category-form-field__button-icon--deselect util--hide-icon"
                  />
                </button>
              </Cell>
            </Grid>
          </div>
        </div>
      )}

      {submissionUnlocked && !(questionCategory.name.includes("Guided Optional") || questionCategory.name.includes("Self-Guided Optional")) && deselectCategory && (
        <div className="category-form-field-wrap">
          <div className={`category-form-field category-form-field--selected category-form-field--${questionCategoryModifier(questionCategory)}`}>
            <Grid className="grid-padding-x">
              <Cell small={12} large={7}>
                <span className={`category-form-field__title category-form-field__title--${questionCategoryModifier(questionCategory)}`}>
                  {questionResultsContent(questionCategory.id, 'optionalCategoryName') || questionCategory.name}
                </span>
              </Cell>
              <Cell small={12} large={5} className="text-right">
                <button
                  data-category-id={questionCategory.id}
                  onClick={deselectCategory}
                  ref={(ref) => (categoryFormButtons.current['selected' + questionCategory.id] = ref)}
                  id={`page-function-button--remove-${questionCategory.id}`}
                >
                  <span className="category-form-field__link">Remove</span>
                  <XCircle
                    size={16}
                    className="category-form-field__button-icon category-form-field__button-icon--deselect util--hide-icon"
                  />
                </button>
              </Cell>
            </Grid>

            {showSummary && (
              <div className="category-form-field__styles category-form-field__styles--selected">
                <p className="category-form-field__summary">
                  {questionCategory.description}
                </p>
                <div>
                  <button
                    onClick={openModal}
                    data-modal-id={`question-category-content--${questionCategory.id}`}
                    className="category-form-field__link"
                    id={`page-function-button--view-${questionCategory.id}`}
                  >
                    More
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      {submissionUnlocked && !(questionCategory.name.includes("Guided Optional") || questionCategory.name.includes("Self-Guided Optional")) && selectCategory && (
        <div className="category-form-field-wrap">
          <div className={`category-form-field shadow-sm category-form-field--${questionCategoryModifier(questionCategory)}`}>
            <div style={{ position: 'relative' }}>
              <p className={`category-form-field__title category-form-field__title--${questionCategoryModifier(questionCategory)}`}>
                <InfoCircleFill className="category-form-field__icon" />
                {questionResultsContent(questionCategory.id, 'optionalCategoryName') || questionCategory.name}
              </p>

              <label className='custom-checkbox'>
                <span className="visually-hidden">
                  Select {questionResultsContent(questionCategory.id, 'optionalCategoryName') || questionCategory.name}
                </span>
                <input
                  className="basic-form__input"
                  type="checkbox"
                  data-category-id={questionCategory.id}
                  id={`checkbox--${questionCategoryModifier(questionCategory)}`}
                  onChange={() => handleCheckbox(questionCategoryModifier(questionCategory))}
                  aria-label={`Select ${questionResultsContent(questionCategory.id, 'optionalCategoryName') || questionCategory.name}`}
                />
                <span className="checkmark"></span>
              </label>
            </div>

            {showSummary && (
              <div className="category-form-field__styles category-form-field__styles--deselected">
                <p className="category-form-field__description">{questionCategory.description}</p>
              </div>
            )}
          </div>
        </div>
      )}

      {/* Modal Section */}
      {currentModal === 'question-category-content--' + questionCategory.id && (
        <div
          className="modal-backdrop fade show"
          role="presentation"
          aria-label="Close modal"
          tabIndex={0}
          onClick={closeModal}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              closeModal();
            }
          }}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: 1040
          }}
        >
          <img src="" alt="Close modal" style={{ display: 'none' }} />
        </div>
      )}
      <dialog
        className={`modal fade${currentModal === 'question-category-content--' + questionCategory.id ? ' show d-block' : ''}`}
        tabIndex="-1"
        aria-labelledby={`modal-title-${questionCategory.id}`}
        aria-hidden={currentModal !== 'question-category-content--' + questionCategory.id}
        onClick={closeModal}
        open={currentModal === 'question-category-content--' + questionCategory.id}
        style={{
          backgroundColor: 'transparent',
          zIndex: 1050
        }}
      >
        <div
          className="modal-dialog modal-dialog-centered modal-lg"
          aria-hidden="true"
          onClick={(e) => e.stopPropagation()}
          onKeyDown={(e) => {
            // Allow ESC to close modal for accessibility
            if (e.key === 'Escape') closeModal();
          }}
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title question-category-modal-title w-100 text-center" id={`modal-title-${questionCategory.id}`}>
                {questionResultsContent(questionCategory.id, 'optionalCategoryName') || questionCategory.name}
              </h5>
              <button type="button" className="btn-close-categories" onClick={closeModal} aria-label="Close" />
            </div>

            <div className="modal-body">
              <QuestionCategoryContent categoryId={questionCategory.id} isManagerView={isManagerView} />

              {showNotes && (
                <div className="mt-3">
                  <label htmlFor={`notes--${questionCategory.id}`} className="form-label">Notes</label>
                  <textarea
                    className="form-control"
                    id={`notes--${questionCategory.id}`}
                    name={`notes--${questionCategory.id}`}
                    onChange={handleChange}
                    placeholder="Add any additional notes here..."
                    defaultValue={questionResultsContent(questionCategory.id, 'notes')}
                  />
                </div>
              )}
            </div>

            {showNotes && (
              <div className="modal-footer">
                <button
                  onClick={closeModal}
                  className="page-content__button page-content__button--medium"
                  id={`page-function-button--modal-close-${questionCategory.id}`}
                >
                  Close
                </button>
              </div>
            )}
          </div>
        </div>
      </dialog>
    </>
  );
};

export default QuestionCategory;

QuestionCategory.propTypes = {
  questionCategory: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    name: PropTypes.string.isRequired,
    description: PropTypes.string,
    selfGuided: PropTypes.bool
  }).isRequired,
  openModal: PropTypes.func,
  currentModal: PropTypes.string,
  afterOpenModal: PropTypes.func,
  closeModal: PropTypes.func,
  submissionUnlocked: PropTypes.bool.isRequired,
  handleChange: PropTypes.func,
  questionResultsContent: PropTypes.func.isRequired,
  deselectCategory: PropTypes.func,
  selectCategory: PropTypes.func,
  categoryFormButtons: PropTypes.shape({ current: PropTypes.array }),
  selectedCategories: PropTypes.array,
  showSummary: PropTypes.bool,
  showNotes: PropTypes.bool,
  handleCheckbox: PropTypes.func,
  isManagerView: PropTypes.bool
};
